export default class Cat {
  constructor() {
    this._name = 'Cat';
  }
  get name() {
    return this._name;
  }
}



// WEBPACK FOOTER //
// ./src/cat.js